<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchArchive"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader="{ selectList }">
        <b-button
          v-if="selectList.length"
          variant="outline-danger"
          class="mr-1"
          :disabled="isSubmit"
          @click="groupDelete"
        >
          {{ $t("general.groupDelete") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>
        <b-button
          v-if="selectList.length"
          variant="outline-warning"
          class="mr-1"
          :disabled="isSubmit"
          @click="() => groupArchive(selectList, false)"
        >
          {{ $t("suggestions.unArchive") }} {{ $t("general.group") }} {{ selectList.length ? `(${selectList.length})` : "" }}
        </b-button>
      </template>
      <!-- Column: Archive -->
      <template #cell(archive)="{ item }">
        <b-form-checkbox
          :checked="item.archive"
          class="mt-1"
          switch
          inline
          @change="(val) => toggleArchive(item._id, val)"
        />
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <view-row @click.native="$router.push({name: `pages-feedback-edit`,params: { id: item._id } })" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import BDataTable from '@/components/BDataTable/index.vue'
import '@/components/BDataTable/Actions/DeleteRow.vue'
import '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import { BFormCheckbox, BButton } from 'bootstrap-vue'
import ViewRow from '@/components/BDataTable/Actions/ViewRow.vue'
import useFeedbackList from './useFeedbackList'

export default {
  name: 'SuggestionList',
  components: {
    BButton,
    BDataTable,
    BFormCheckbox,
    LayoutLoading,
    ViewRow,
  },
  setup() {
    const {
      deleteItem,
      fetchArchive,
      fetchList,
      groupArchive,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      toggleArchive,
    } = useFeedbackList()
    return {
      deleteItem,
      fetchArchive,
      fetchList,
      groupArchive,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
      toggleArchive,
    }
  },
}
</script>
